define('view/controller/booking/timezone/CompanyTimeView',['require','lib/view/LayoutView','lib/view/ModalRegion','view/controller/booking/timezone/TimeZoneSelectDialogView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var TimeZoneSelectDialogView = require('view/controller/booking/timezone/TimeZoneSelectDialogView');

    /**
     * Company time view. with select user timezone
     *
     * @class CompanyTimeView
     */
    return LayoutView.extend({

        template: '#company_time_view',

        ui: {
            changeTimeZoneButton: '#sb_change_timezone'
        },
        events: {
            'click @ui.changeTimeZoneButton': 'showTimeZoneDialog'
        },
        _clientTimeZone: null,
        _companyTimeZone: null,
        _timer: null,

        initialize: function () {
            this._clientTimeZone = this.getOption('clientTimeZone');
            this._companyTimeZone = this.getOption('companyTimeZone');

            this.listenTo(this._companyTimeZone, 'sync', this.render);
            this.listenTo(this._clientTimeZone, 'sync', this.render);

            if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
                if (this._clientTimeZone.isNew()) {
                    this._clientTimeZone.fetch();
                }
            }
            if (this._companyTimeZone.isNew()) {
                this._companyTimeZone.fetch();
            }

            this._timer = setInterval(_.bind(this.renderOrStop, this), 1000);
        },

        renderOrStop: function () {
            if (!this.isDestroyed) {
                this.render();
            } else {
                clearInterval(this._timer);
            }
        },

        showTimeZoneDialog: function () {
            var region = new ModalRegion();
            var view = new TimeZoneSelectDialogView({
                model: this._clientTimeZone,
                companyTimeZone: this._companyTimeZone,
                clientTimeZone: this._clientTimeZone,
                timeZoneCollection: this.getOption('timeZoneCollection')
            });
            region.show(view);
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);

            result.current_company_time = this._companyTimeZone.getCurrentDateTime();
            result.company_time_zone = this._companyTimeZone.get('name');

            if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
                result.current_client_time = this._clientTimeZone.getCurrentDateTime();
                result.client_time_zone = this._clientTimeZone.get('name');

                result.show_client_time = true;
            }

            return result;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'company_time'
            });
        }

    });

});
